import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function DashboardsAPI(): BringozApi {
  return {
    base: `/dashboards`,
    infiniteScroll: {
      address: `/dashboards`,
      cmd: 'GET'
    },
    actions: {
      createDashboard: {
        address: '',
        cmd: 'PUT',
        updateable: false
      },
      updateDashboard: {
        address: '{id}',
        cmd: 'POST',
        updateable: false
      },
      deleteDashboard: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: false
      },
      getDashboard: {
        address: '{id}',
        cmd: 'GET',
        updateable: false
      },
      getConfigurations: {
        address: 'datasources/configuration',
        cmd: 'GET',
        updateable: false
      },
      getDashboardWidgetData: {
        address: 'datasources/{datasource}',
        cmd: 'GET',
        updateable: false
      },
      getDashboardWidgetDataPost: {
        address: 'datasources/{datasource}',
        cmd: 'POST',
        updateable: false
      },
      changeDashboardPublicState : {
        address: 'publicState/{dashboardId}',
        cmd: 'POST',
        updateable: false
      },

    }
  }
}

angular
  .module('bringoz.admin.dashboards')
  .factory('dashboardsAPI', DashboardsAPI);
